var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/info-menu/HelpMenu.tsx",
  _this = this;
import React, { useContext } from 'react';
import { Sheet } from '@wds/sheet';
import { List } from '@wds/list';
import { IconHelpFilled } from '@wds/icons';
import { t, defineMessages } from '@sm/intl';
import { Responsive } from '@wds/responsive';
import { MenuItems } from './MenuItems';
import HeaderContext from '../../HeaderContext';
import { NavButton } from '../nav-button';
import useStyles from './useStyles';
import { getHelpCenterLink } from '../../../../../helpers/getHelpLink';
import { getResourcesItems } from '../../../components/Drawer/getDrawerData';
import { StaticContext } from '../../../../StaticContext';
var COPYHELP = defineMessages({
  HELP: {
    id: 'HelpMenu.help',
    defaultMessage: 'Help',
    description: '[Type: Label][Vis.: high] - This is the Help title of the side menu.'
  }
});
var HelpMenu = function HelpMenu(_ref) {
  var _HEADER_EXP$helpPanel;
  var showHelp = _ref.showHelp,
    toggleHelp = _ref.toggleHelp;
  var classes = useStyles();
  var _useContext = useContext(HeaderContext),
    lang = _useContext.lang,
    pageURL = _useContext.pageURL;
  var itemsData = getResourcesItems(lang) || [];
  var _useContext2 = useContext(StaticContext),
    _useContext2$HEADER_E = _useContext2.HEADER_EXP,
    HEADER_EXP = _useContext2$HEADER_E === void 0 ? {} : _useContext2$HEADER_E;
  var hostname = window.location.hostname;
  var helpUrl = getHelpCenterLink(lang, {
    path: 'embed',
    params: {
      ut_source: 'product',
      ut_source3: 'header',
      page: pageURL
    }
  });
  if (hostname.includes('localmonkey') || hostname.includes('monkeytest')) {
    helpUrl = helpUrl.replace('surveymonkey', 'monkeytest3');
  }

  // Help center iframe experiment
  // https://momentiveai.atlassian.net/browse/ROADMAP-4595
  // https://admin.monkeytest3.com/experiments/surveymonkey/698746
  var helpPanelTreatment = HEADER_EXP === null || HEADER_EXP === void 0 ? void 0 : (_HEADER_EXP$helpPanel = HEADER_EXP.helpPanel) === null || _HEADER_EXP$helpPanel === void 0 ? void 0 : _HEADER_EXP$helpPanel.treatment;
  var showHelpCenterIframe = helpPanelTreatment === 'header_help_center_iframe_variant';
  return /*#__PURE__*/React.createElement(Responsive, {
    minWidth: "xl",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 5
    }
  }, function (matches) {
    return matches ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NavButton, {
      onClick: toggleHelp,
      label: "Open Help menu",
      active: showHelp,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 63,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(IconHelpFilled, {
      title: "help icon",
      size: "lg",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 68,
        columnNumber: 15
      }
    })), /*#__PURE__*/React.createElement(Sheet, {
      show: showHelp,
      onClose: toggleHelp,
      offsetTop: 48,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70,
        columnNumber: 13
      }
    }, showHelpCenterIframe ? /*#__PURE__*/React.createElement("iframe", {
      title: "Help center",
      width: "100%",
      height: "100%",
      src: helpUrl,
      className: classes.helpIframe,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 72,
        columnNumber: 17
      }
    }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Sheet.Header, {
      header: t(COPYHELP.HELP),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 81,
        columnNumber: 19
      }
    }), /*#__PURE__*/React.createElement(Sheet.Body, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 82,
        columnNumber: 19
      }
    }, /*#__PURE__*/React.createElement(List, {
      interactive: true,
      noRules: true,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 83,
        columnNumber: 21
      }
    }, itemsData.map(function (props) {
      return props && /*#__PURE__*/React.createElement(MenuItems, Object.assign({}, props, {
        key: props.title,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 86,
          columnNumber: 36
        }
      }));
    })))))) : itemsData.map(function (props) {
      return props && /*#__PURE__*/React.createElement(MenuItems, Object.assign({}, props, {
        key: props.title,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 96,
          columnNumber: 31
        }
      }));
    });
  });
};
export default HelpMenu;
export { HelpMenu };
//# sourceMappingURL=HelpMenu.js.map